module.exports = __webpack_public_path__ + "static/media/18.c6d6d64b.jpeg";